import { useEffect, useState } from "react";
import { getModifiedDate, parseLocalDate } from "../funcs/helperFuncs";

import ClearFilter from "../assets/clear_filter.svg";

export default function SearchDates({ data, setState }) {
  // local
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const resetDates = () => {
    setStartDate("");
    setEndDate("");
    setState(data);
  };

  useEffect(() => {
    if (data && startDate && endDate) {
      const loads = [];
      var start = new parseLocalDate(startDate);
      start.setHours(0, 0, 0, 0);
      var end = new parseLocalDate(endDate);
      end.setHours(23, 59, 59, 999);
      data.forEach((l) => {
        var modDate = getModifiedDate(l.delivered_date);
        if (modDate >= start && modDate <= end) {
          loads.push(l);
        }
      });
      setState(loads);
    }
  }, [data, startDate, endDate, setState]);
  return (
    data && (
      <div className="d-flex">
        <label
          htmlFor="start_date"
          className="col-form-label bold-label"
          style={{ margin: "0 10px 0 0" }}
        >
          Start
        </label>
        <input
          type="date"
          name="start_date"
          placeholder="Start Date"
          className="form-control"
          style={{ margin: "0 10px 0 0" }}
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        />
        <label
          htmlFor="start_date"
          className="col-form-label bold-label"
          style={{ margin: "0 10px 0 0" }}
        >
          End
        </label>
        <input
          type="date"
          name="end_date"
          placeholder="Start Date"
          className="form-control"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        />
        <div className="col-auto" style={{ margin: "0 0 0 10px" }}>
          {startDate !== "" && endDate !== "" && (
            <img
              src={ClearFilter}
              alt="clear"
              className="project-delete-image"
              onClick={resetDates}
            />
          )}
        </div>
      </div>
    )
  );
}
